import React, { useEffect, useState } from 'react'

import { goodfellasApi } from '../../apis'

type ProfileSummaryResponse = {
  summary: string
  source: 'cache' | 'fresh'
  generatedAt: string
}

interface ProfileAiSummaryProps {
  phoneNumber?: string
  displayName?: string
}

export default function ProfileAiSummary({
  phoneNumber,
  displayName: _displayName,
}: ProfileAiSummaryProps) {
  const [loading, setLoading] = useState(true)
  const [summary, setSummary] = useState<string | null>(null)

  useEffect(() => {
    if (!phoneNumber) {
      setLoading(false)
      return
    }

    let cancelled = false
    const fetchSummary = async () => {
      setLoading(true)
      try {
        const response = await goodfellasApi.get<ProfileSummaryResponse>(
          `/profile-summary/phone/${encodeURIComponent(phoneNumber)}`,
        )
        const text = String(response.data?.summary ?? '').trim()
        if (!cancelled) setSummary(text || null)
      } catch {
        if (!cancelled) setSummary(null)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    fetchSummary()
    return () => {
      cancelled = true
    }
  }, [phoneNumber])

  // Don't render anything if no summary and not loading
  if (!loading && !summary) return null

  return (
    <div className="bg-gradient-to-br from-slate-800/60 to-slate-900/60 rounded-2xl p-4 sm:p-5 border border-white/5 relative overflow-hidden">
      {/* Sparkle icon */}
      <div className="absolute top-3 left-3 text-amber-400/80 text-lg">✨</div>

      {loading ? (
        <div className="ml-7 space-y-2">
          <div className="h-4 w-3/4 rounded bg-gradient-to-r from-slate-700/50 via-slate-600/50 to-slate-700/50 animate-pulse" />
          <div className="h-4 w-1/2 rounded bg-gradient-to-r from-slate-700/50 via-slate-600/50 to-slate-700/50 animate-pulse" />
        </div>
      ) : (
        <p className="ml-7 text-slate-200 text-sm sm:text-base italic leading-relaxed">
          {summary}
        </p>
      )}

      {/* Subtle label */}
      <div className="mt-3 ml-7 flex items-center gap-1.5 text-xs text-slate-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3.5 w-3.5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 10V3L4 14h7v7l9-11h-7z"
          />
        </svg>
        <span>Análise da Jiulia</span>
      </div>
    </div>
  )
}
